import axios from "axios";

const publicApi = axios.create({ baseURL: process.env.REACT_APP_BASE_URL });

const handle = async (label, promise) => {
  try {
    console.log(`[SimilarWordsService] ${label}`);
    const res = await promise;
    console.log(`[SimilarWordsService] ${label} response:`, res.status);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error(`[SimilarWordsService] ${label} failed:`, err.response?.status, err.response?.data);
    return { status: err.response?.status || 500, data: null, message: err.response?.data?.message || "Failed" };
  }
};

export const fetchGroups = () => handle("Fetch groups", publicApi.get("/public/similar-words/groups"));
export const fetchGroupById = (id) => handle(`Fetch group ${id}`, publicApi.get(`/public/similar-words/groups/${id}`));
export const fetchWordsByGroup = (groupId) => handle(`Fetch words for group ${groupId}`, publicApi.get(`/public/similar-words/groups/${groupId}/words`));
